var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"code",staticClass:"text-editor ph-no-capture",on:{"keydown":function($event){$event.stopPropagation();}}})}
var staticRenderFns = []

export { render, staticRenderFns }